import { render, staticRenderFns } from "./DetailedPricingCladifyService.vue?vue&type=template&id=7f220b16&scoped=true"
import script from "./DetailedPricingCladifyService.vue?vue&type=script&lang=js"
export * from "./DetailedPricingCladifyService.vue?vue&type=script&lang=js"
import style0 from "./DetailedPricingCladifyService.vue?vue&type=style&index=0&id=7f220b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f220b16",
  null
  
)

export default component.exports